import { io } from "socket.io-client";
import config from "./appConfig";

export const socket = io(config.socket_api, {
    autoConnect: false,
    transports: ["websocket", "polling"],
});